import { connect } from 'react-redux'
import UI from './UI'
import { selectTagForFreeCoursesAction } from '../store'

const mapStateToProps = ({ catalog }) => ({
  selectedCategory: catalog.selectedCategory,
  loading: catalog.loadingCategories,
  categories: catalog.categories,
  selectedFreeCoursesTag: catalog.selectedFreeCoursesTag
})

const mapDispatchToProps = (dispatch) => ({
  handleTagClick: (tag) => dispatch(selectTagForFreeCoursesAction(tag, 6))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
